module.exports = __webpack_public_path__ + "static/img/LOGO.0d6efe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/LOGO.png
// module id = vW9M
// module chunks = 19